module.exports = __webpack_public_path__ + "img/reset-step-four.ec8d560f.png";